// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.J_axeQzDxmwDOL5N{max-width:365px}.BB52ch2VDv0qO_6C{max-width:300}.sB46mIPNW4YdMjhR{text-align:right}.sB46mIPNW4YdMjhR .eMYnzgK6qssogPjr{display:inline-block}.Bzk2Qvj_J1cbRo49 .VMv3Tjpdg743dh_Z{flex-grow:1}.Bzk2Qvj_J1cbRo49 .kQqb5yvRHoB_kfjU{width:70px}.qeZ1M25xz4aQtPVC{min-width:0}.QWPuNc9PCZAUEj8y{display:flex;justify-content:flex-end;gap:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"description": `J_axeQzDxmwDOL5N`,
	"settingDescription": `BB52ch2VDv0qO_6C`,
	"toggleContainer": `sB46mIPNW4YdMjhR`,
	"toggleWrapper": `eMYnzgK6qssogPjr`,
	"disallowedWordListInput": `Bzk2Qvj_J1cbRo49`,
	"inputField": `VMv3Tjpdg743dh_Z`,
	"addWordButton": `kQqb5yvRHoB_kfjU`,
	"disallowedWordChip": `qeZ1M25xz4aQtPVC`,
	"controlsContainer": `QWPuNc9PCZAUEj8y`
};
export default ___CSS_LOADER_EXPORT___;
